import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-8" }, " 親なしサブコレクション管理ページ ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-8 text-sm text-gray-500 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 教室移動などで、親のドキュメントが無いのに、配下のサブコレクションだけが残ったデータを確認し、削除します。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 毎週日曜の早朝に自動で検知します。削除は、内容を確認して、確認ダイアログで承認したときだけ実行されます。 ")
], -1)
const _hoisted_5 = { class: "w-full max-w-5xl mb-6" }
const _hoisted_6 = { class: "bg-blue-50 rounded-md border border-blue-200 p-4 text-sm" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-bold mb-1" }, "直近の検知", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" まだ検知が実行されていません。 ")
const _hoisted_9 = { class: "w-full max-w-5xl mb-4 flex gap-4 items-end" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "block text-xs text-gray-500 mb-1" }, "学校", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "" }, "すべて", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "block text-xs text-gray-500 mb-1" }, "状態", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "" }, "すべて", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "block text-xs text-gray-500 mb-1" }, "分類", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "" }, "すべて", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("再読み込み")
const _hoisted_17 = { class: "text-sm text-gray-500" }
const _hoisted_18 = { class: "w-full max-w-5xl" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center gap-4 mb-2 text-sm"
}
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" すべて選択 ")
const _hoisted_22 = { class: "text-gray-600" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-yellow-700"
}
const _hoisted_24 = {
  key: 1,
  class: "text-center text-sm text-gray-500 py-8"
}
const _hoisted_25 = {
  key: 2,
  class: "border border-gray-200 rounded-md divide-y divide-gray-200"
}
const _hoisted_26 = { class: "flex-1 min-w-0" }
const _hoisted_27 = { class: "font-bold" }
const _hoisted_28 = { class: "font-mono break-all text-xs" }
const _hoisted_29 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_30 = { class: "text-xs text-gray-600 w-20" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 内容を確認 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ホームへ戻る ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")
  const _component_OrphanBulkDeletionModal = _resolveComponent("OrphanBulkDeletionModal")
  const _component_OrphanDeletionModal = _resolveComponent("OrphanDeletionModal")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("section", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.latestRun)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                _createVNode("div", null, _toDisplayString(_ctx.formatDate(_ctx.latestRun.finishedAt)) + " / 走査 " + _toDisplayString(_ctx.latestRun.scannedSchools) + " 校・" + _toDisplayString(_ctx.latestRun.scannedClassrooms) + " 教室 / 新規 " + _toDisplayString(_ctx.latestRun.newFindings) + " 件 / " + _toDisplayString(_ctx.latestRun.cycleCompleted
                  ? "周回を完了"
                  : "途中（次の実行で続きから）"), 1)
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_8
              ], 64))
        ])
      ]),
      _createVNode("section", _hoisted_9, [
        _createVNode("div", null, [
          _hoisted_10,
          _withDirectives(_createVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.schoolFilter = $event)),
            class: "border border-gray-300 rounded-md px-3 py-2"
          }, [
            _hoisted_11,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schoolOptions, (school) => {
              return (_openBlock(), _createBlock("option", {
                key: school.id,
                value: school.id
              }, _toDisplayString(school.label), 9, ["value"]))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.schoolFilter]
          ])
        ]),
        _createVNode("div", null, [
          _hoisted_12,
          _withDirectives(_createVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.statusFilter = $event)),
            class: "border border-gray-300 rounded-md px-3 py-2"
          }, [
            _hoisted_13,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusLabels, (label, key) => {
              return (_openBlock(), _createBlock("option", {
                key: key,
                value: key
              }, _toDisplayString(label), 9, ["value"]))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.statusFilter]
          ])
        ]),
        _createVNode("div", null, [
          _hoisted_14,
          _withDirectives(_createVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.categoryFilter = $event)),
            class: "border border-gray-300 rounded-md px-3 py-2"
          }, [
            _hoisted_15,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryLabels, (label, key) => {
              return (_openBlock(), _createBlock("option", {
                key: key,
                value: key
              }, _toDisplayString(label), 9, ["value"]))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.categoryFilter]
          ])
        ]),
        _createVNode(_component_MButton, { onClick: _ctx.load }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.filtered.length) + " 件", 1)
      ]),
      _createVNode("section", _hoisted_18, [
        (_ctx.filtered.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, [
                _createVNode("input", {
                  type: "checkbox",
                  checked: _ctx.allSelected,
                  disabled: _ctx.selectableCount === 0,
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAll && _ctx.toggleAll(...args)))
                }, null, 40, ["checked", "disabled"]),
                _hoisted_21
              ]),
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedIds.length) + " 件選択中（上限 " + _toDisplayString(_ctx.bulkMax) + " 件） ", 1),
              (_ctx.limitNotice)
                ? (_openBlock(), _createBlock("span", _hoisted_23, " 上限 " + _toDisplayString(_ctx.bulkMax) + " 件まで選びました ", 1))
                : _createCommentVNode("", true),
              _createVNode(_component_MButton, {
                size: "sm",
                color: "red-600",
                disabled: _ctx.selectedIds.length === 0,
                onClick: _ctx.startBulk
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 選択した " + _toDisplayString(_ctx.selectedIds.length) + " 件を削除 ", 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filtered.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_24, " 該当する検知結果はありません。 "))
          : (_openBlock(), _createBlock("div", _hoisted_25, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filtered, (finding) => {
                return (_openBlock(), _createBlock("div", {
                  key: finding.id,
                  class: "p-3 flex items-center gap-4 text-sm"
                }, [
                  _createVNode("input", {
                    type: "checkbox",
                    checked: _ctx.isSelected(finding.id),
                    disabled: _ctx.checkboxDisabled(finding),
                    title: _ctx.checkboxTitle(finding),
                    onChange: ($event: any) => (_ctx.toggle(finding.id))
                  }, null, 40, ["checked", "disabled", "title", "onChange"]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.schoolLabel(finding)) + " / " + _toDisplayString(_ctx.classroomLabel(finding)), 1),
                    _createVNode("div", _hoisted_28, _toDisplayString(finding.path), 1),
                    _createVNode("div", _hoisted_29, _toDisplayString(finding.subcollections.join("、")) + " / 検知 " + _toDisplayString(_ctx.formatDate(finding.detectedAt)), 1)
                  ]),
                  _createVNode("span", {
                    class: ["px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap", _ctx.categoryBadgeClass(finding.category)]
                  }, _toDisplayString(_ctx.categoryLabels[finding.category]), 3),
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.statusLabels[finding.status]), 1),
                  _createVNode(_component_MButton, {
                    size: "sm",
                    disabled: !_ctx.canOpen(finding),
                    onClick: ($event: any) => (_ctx.openPreview(finding))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]))
              }), 128))
            ]))
      ]),
      _createVNode(_component_MButton, {
        class: "mt-12 mb-12",
        onClick: _ctx.moveToHome
      }, {
        default: _withCtx(() => [
          _hoisted_32
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.bulkStage)
      ? (_openBlock(), _createBlock(_component_OrphanBulkDeletionModal, {
          key: 0,
          stage: _ctx.bulkStage,
          progress: _ctx.bulkProgress,
          deletable: _ctx.bulkDeletable,
          excluded: _ctx.bulkExcluded,
          outcome: _ctx.bulkOutcome,
          onClose: _ctx.closeBulk,
          onExecute: _ctx.executeBulk
        }, null, 8, ["stage", "progress", "deletable", "excluded", "outcome", "onClose", "onExecute"]))
      : _createCommentVNode("", true),
    (_ctx.preview)
      ? (_openBlock(), _createBlock(_component_OrphanDeletionModal, {
          key: 1,
          preview: _ctx.preview,
          running: _ctx.running,
          result: _ctx.result,
          onClose: _ctx.closeModal,
          onExecute: _ctx.execute
        }, null, 8, ["preview", "running", "result", "onClose", "onExecute"]))
      : _createCommentVNode("", true)
  ]))
}